import React, { FC, useEffect, useRef } from "react";

import { useLayout } from "../../hooks/use-layout";

import { Button, ButtonVariant, Dialog, Theme } from "@in/component-library";

interface UpdatePhoneConfirmComponentProps {
  displayConfirmPhoneModal: boolean;
  onClose: () => void;
}

const UpdatePhoneConfirm: FC<UpdatePhoneConfirmComponentProps> = ({ displayConfirmPhoneModal, onClose }) => {
  const { translations } = useLayout();
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (displayConfirmPhoneModal) {
      ref?.current?.showModal();
    } else {
      ref?.current?.close();
    }
  }, [displayConfirmPhoneModal]);

  return (
    <Dialog
      className="profile-form__modal"
      ref={ref}
      title={translations.changeEmailAdress}
      closeButton={{
        "aria-label": translations.close,
        onClick: () => {
          onClose();
        }
      }}
    >
      <p className="profile-form__phone-confirmation">{translations.phoneNumberUpdatedLabel}</p>

      <div aria-live="polite" className="profile-form__button">
        <Button type="button" variant={ButtonVariant.Solid} theme={Theme.Neutral} onClick={onClose}>
          {translations.verifyEmailCloseModal}
        </Button>
      </div>
    </Dialog>
  );
};

export default UpdatePhoneConfirm;
